<template>
    <b-container v-if="notificationSettings.length" class="mt-4 mb-4">
      <b-row class="content-settings mt-4">
        <b-col cols="12">
          <div class="d-flex align-items-center col">
            <div class="p2 mr-4">
              <img width="13" src="@/assets/notifications-bell-button.svg" alt="bell-button" />
            </div>
            <div class="p2">
              <span class="notification-container-title">Notificações</span>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Linha que exibe pedidos confirmados e canais -->
      <b-row
        v-for="notification in filteredNotifications"
        class="pt-4 notifications"
        style="background-color:#fff"
        :key="notification.topic"
      >
        <b-col cols="12" class="d-flex topic">
          <b-col class="d-flex align-items-center topic-title">
            <div class="p2 mr-3">
              <img
                v-if="notification.img == 'pedidos-confirmados'"
                width="20"
                src="../assets/pedidos-confirmados.svg"
                :alt="notification.topic"
              />
              <img
                v-if="notification.img == 'pagamento-realizado'"
                width="20"
                src="../assets/pagamento-realizado.svg"
                :alt="notification.topic"
              />
            </div>
            <div class="p2">
              <span
                v-if="notification.img === 'pagamento-realizado'"
                class="green notification-container-type"
              >{{ notification.topic }}</span>

              <span v-else class="notification-container-type">
                {{ notification.topic }}
              </span>
            </div>
          </b-col>
          <b-col class="d-flex align-items-center justify-content-end">
            <div class="p2">
              <span class="notification-container-text">
                Recebimento de notificações
              </span>
            </div>
            <div class="p2 ml-3">
              <div
                :class="{'btn-toggle-active': notification.isActive,
                'btn-toggle-deactive': !notification.isActive}"
                v-on:click="disableAll(notification)"
              >
                <div class="status"></div>
              </div>
            </div>
          </b-col>
        </b-col>

        <b-col v-if="notification.isActive" class="mt-4 channel-configuration pr-0 pl-0" cols="12">
          <b-col cols="12" class="col-channel-selector-title">
            <div class="col pt-2 pb-2">
              <span class="text-channel-selec">Selecione os canais:</span>
            </div>
          </b-col>
          <b-col cols="12 pt-4">
            <div
              class="col"
              v-for="channel in notification.channel"
              :key="channel.idtAffNotification+'_'+channel.desChannel"
            >
              <input
                type="checkbox"
                class="mr-2"
                :value="channel.desChannel"
                v-on:change="disableByChannel(channel)"
                :checked="channel.status"
                :id="channel.idtAffNotification+'_'+channel.desChannel"
              />
              <label
                :for="channel.idtAffNotification+'_'+channel.desChannel"
                class="control-text"
              >Notificar com {{ channel.desChannel }}</label>
            </div>
          </b-col>
        </b-col>
      </b-row>
    </b-container>

</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NotificationForm',
  data() {
    return {
    };
  },
  methods: {
    ...mapActions(['disableNotification', 'disableNotificationByChannel', 'getNotificationSettings']),
    disableAll(notification) {
      notification.channel.forEach(async (element) => {
        element.status = !element.status;
        await this.disableNotification(element);
      });
    },
    async disableByChannel(channel) {
      channel.status = !channel.status;
      await this.disableNotificationByChannel(channel);
    },
  },
  computed: {
    ...mapGetters(['notificationSettings']),
    filteredNotifications() {
      return this.notificationSettings.map((item) => {
        const isActive = item.channel.filter(ch => ch.status === true).length > 0;
        const img = item.topic.replace(' ', '-').toLowerCase();
        return {
          topic: item.topic,
          channel: item.channel,
          isActive,
          img,
        };
      });
    },
  },
  async created() {
    await this.getNotificationSettings();
  },
};
</script>

<style lang="scss">
.topic {
  background: #fff;
}

.page-title {
  color: #7a3805;
  font-size: 20px;
  font-weight: bold;
}
.notification-container-title {
  color: #7a3805;
  font-size: 18px;
  font-weight: bold;
}

.green {
  color: #57b965 !important;
}

.notification-container-type {
  color: #7a3805;
  font-size: 16px;
}

.notification-container-text {
  color: #515151;
  font-size: 16px;
  font-weight: lighter;
}

.control-text {
  color: #515151;
  font-size: 16px;
  font-weight: lighter;
}

.content-settings {
  background: #f6f6f6 0% 0% no-repeat padding-box;
  padding-top: 25px;
  padding-bottom: 25px;
}

.channel-configuration,
.channel-configuration-controls {
  background-color: #efefef;
}

.text-channel-selec {
  font-size: 14px;
  color: #565656;
}

.col-channel-selector-title {
  border-bottom: 2px solid #dedddb;
}

input[type="checkbox"]:checked {
  background-color: #e38931 !important;
  color: #fff;
}

.notification-container-type-payment {
  color: #57b965;
  font-size: 16px;
}

/* css to toggle button */
.btn-toggle-active {
  width: 34px;
  height: 14px;
  border-radius: 20px;
  background-color: #ecc2bc !important;
  position: relative;
  cursor: pointer;
}

.btn-toggle-active .status {
  width: 18px;
  height: 18px;
  background-color: #d06859 !important;
  border-radius: 100%;
  position: absolute;
  top: -2px;
  right: 0 !important;
}

.btn-toggle-deactive {
  width: 34px;
  height: 14px;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  background-color: #b8b8b8;
}

.btn-toggle-deactive .status {
  width: 18px;
  height: 18px;
  left: 0 !important;
  background-color: #818181;
  position: absolute;
  border-radius: 100%;
  top: -2px;
}

 @media screen and (max-width: $sm) {
    .topic-title{
      width: 100%;
    }
  }
</style>
